import { Modal, Offcanvas } from "bootstrap";

/** @type {Array<{ el: Element; pointerEvents: string; inert: boolean; focustrap?: { activate: () => void; deactivate: () => void } }>} */
let suspendedLayers = [];

/**
 * While the session lock overlay is shown, open modals must not capture focus
 * or pointer events (Bootstrap focus trap blocks the lock password field).
 */
export function preparePageForSessionLock() {
  releasePageFromSessionLock();

  document.querySelectorAll(".modal-backdrop, .offcanvas-backdrop").forEach((el) => {
    suspendedLayers.push({
      el,
      pointerEvents: el.style.pointerEvents,
      inert: el.hasAttribute("inert"),
    });
    el.style.pointerEvents = "none";
    el.setAttribute("inert", "");
  });

  document.querySelectorAll(".modal.show, .offcanvas.show").forEach((el) => {
    const entry = {
      el,
      pointerEvents: el.style.pointerEvents,
      inert: el.hasAttribute("inert"),
      focustrap: undefined,
    };

    try {
      const instance =
        Modal.getInstance(el) ||
        Offcanvas.getInstance(el);
      const trap = instance?._focustrap;
      if (trap && typeof trap.deactivate === "function") {
        trap.deactivate();
        entry.focustrap = trap;
      }
    } catch {
      // ignore private API failures
    }

    el.style.pointerEvents = "none";
    el.setAttribute("inert", "");
    suspendedLayers.push(entry);
  });
}

export function releasePageFromSessionLock() {
  suspendedLayers.forEach(({ el, pointerEvents, inert, focustrap }) => {
    el.style.pointerEvents = pointerEvents;
    if (inert) {
      el.setAttribute("inert", "");
    } else {
      el.removeAttribute("inert");
    }

    if (focustrap && typeof focustrap.activate === "function") {
      try {
        focustrap.activate();
      } catch {
        // ignore
      }
    }
  });

  suspendedLayers = [];
}
